export default __webpack_public_path__ + "static/media/fols.ac261d3c.svg";